const trimTrailingSlash = (value) => String(value || '').replace(/\/+$/, '');

export function getBackendBase({
  nodeEnv = process.env.NODE_ENV,
  configuredBackend = process.env.REACT_APP_BACKEND_URL,
} = {}) {
  if (nodeEnv === 'production') return '';
  return trimTrailingSlash(configuredBackend);
}

export function getApiBase(options) {
  return `${getBackendBase(options)}/api`;
}

export function resolveApiUrl(path, query, options) {
  const apiBase = getApiBase(options);
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  const params = new URLSearchParams();

  Object.entries(query || {}).forEach(([key, value]) => {
    if (value === undefined || value === null || value === '') return;
    if (Array.isArray(value)) value.forEach((item) => params.append(key, item));
    else params.set(key, String(value));
  });

  const queryString = params.toString();
  return `${apiBase}${normalizedPath}${queryString ? `?${queryString}` : ''}`;
}

export const API_BASE = getApiBase();
